<template>
  <select :value="modelValue" @change="onChange">
    <option v-for="(item, index) in this.options" :key="index" :value="item.value">{{item.label ? item.label : item.value}}</option>
  </select>  
</template>
<script>
export default {
  name: "SelectOption",
        props: {
            modelValue: null,
            options: Array
        },

        emits: ["update:modelValue", "change"],

        methods: {
            onChange(e) {
                const index = e.target.selectedIndex;
                const selectedObject = this.options[index].value;

                this.$emit("update:modelValue", selectedObject);
                this.$emit("change", selectedObject);
            }
        }
};
</script>
